<template>
    <div class="form-group">
        <label :for="id">{{ label }}</label>
        <b-form-select :id="id" :value="modelValue" @change="e => $emit('input', e)" :options="options"
            class="form-control" :class="validation && validation.length > 0 ? 'is-invalid' : ''" />
        <small v-if="validation && validation.length > 0" class="text-danger">
            {{ validation.join(', ') }}
        </small>
    </div>
</template>

<script>
import {
    BFormSelect,
} from 'bootstrap-vue'
export default {
    components: {
        BFormSelect,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        modelValue: {
            type: '',
        },
        options: {
            type: Array,
            required: true,
        },
        validation: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['update:modelValue'],
    methods: {
        updateValue(event) {
            this.$emit('update:modelValue', event);
        },
    },
};
</script>
